module.exports = __webpack_public_path__ + "static/media/user1.84c0af2a.png";